var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
* @vue/runtime-dom v3.4.26
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
import { h, BaseTransition, BaseTransitionPropsValidators, assertNumber, getCurrentInstance, warn, onMounted, watchPostEffect, onUnmounted, Fragment, Static, camelize, callWithAsyncErrorHandling, defineComponent, nextTick, createVNode, useTransitionState, onUpdated, toRaw, getTransitionRawChildren, setTransitionHooks, resolveTransitionHooks, isRuntimeOnly, createRenderer, createHydrationRenderer } from '@vue/runtime-core';
export * from '@vue/runtime-core';
import { extend, isObject, toNumber, isArray, isString, hyphenate, capitalize, isSpecialBooleanAttr, includeBooleanAttr, isFunction, NOOP, isOn, isModelListener, camelize as camelize$1, EMPTY_OBJ, looseToNumber, looseIndexOf, isSet, looseEqual, invokeArrayFns, isHTMLTag, isSVGTag, isMathMLTag } from '@vue/shared';
var svgNS = "http://www.w3.org/2000/svg";
var mathmlNS = "http://www.w3.org/1998/Math/MathML";
var doc = typeof document !== "undefined" ? document : null;
var templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
var nodeOps = {
    insert: function (child, parent, anchor) {
        parent.insertBefore(child, anchor || null);
    },
    remove: function (child) {
        var parent = child.parentNode;
        if (parent) {
            parent.removeChild(child);
        }
    },
    createElement: function (tag, namespace, is, props) {
        var el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : doc.createElement(tag, is ? { is: is } : void 0);
        if (tag === "select" && props && props.multiple != null) {
            el.setAttribute("multiple", props.multiple);
        }
        return el;
    },
    createText: function (text) { return doc.createTextNode(text); },
    createComment: function (text) { return doc.createComment(text); },
    setText: function (node, text) {
        node.nodeValue = text;
    },
    setElementText: function (el, text) {
        el.textContent = text;
    },
    parentNode: function (node) { return node.parentNode; },
    nextSibling: function (node) { return node.nextSibling; },
    querySelector: function (selector) { return doc.querySelector(selector); },
    setScopeId: function (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent: function (content, parent, anchor, namespace, start, end) {
        var before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) {
            while (true) {
                parent.insertBefore(start.cloneNode(true), anchor);
                if (start === end || !(start = start.nextSibling))
                    break;
            }
        }
        else {
            templateContainer.innerHTML = namespace === "svg" ? "<svg>".concat(content, "</svg>") : namespace === "mathml" ? "<math>".concat(content, "</math>") : content;
            var template = templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                var wrapper = template.firstChild;
                while (wrapper.firstChild) {
                    template.appendChild(wrapper.firstChild);
                }
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
var TRANSITION = "transition";
var ANIMATION = "animation";
var vtcKey = Symbol("_vtc");
var Transition = function (props, _a) {
    var slots = _a.slots;
    return h(BaseTransition, resolveTransitionProps(props), slots);
};
Transition.displayName = "Transition";
var DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [String, Number, Object],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
var TransitionPropsValidators = Transition.props = /* @__PURE__ */ extend({}, BaseTransitionPropsValidators, DOMTransitionPropsValidators);
var callHook = function (hook, args) {
    if (args === void 0) { args = []; }
    if (isArray(hook)) {
        hook.forEach(function (h2) { return h2.apply(void 0, __spreadArray([], __read(args), false)); });
    }
    else if (hook) {
        hook.apply(void 0, __spreadArray([], __read(args), false));
    }
};
var hasExplicitCallback = function (hook) {
    return hook ? isArray(hook) ? hook.some(function (h2) { return h2.length > 1; }) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
    var baseProps = {};
    for (var key in rawProps) {
        if (!(key in DOMTransitionPropsValidators)) {
            baseProps[key] = rawProps[key];
        }
    }
    if (rawProps.css === false) {
        return baseProps;
    }
    var _a = rawProps.name, name = _a === void 0 ? "v" : _a, type = rawProps.type, duration = rawProps.duration, _b = rawProps.enterFromClass, enterFromClass = _b === void 0 ? "".concat(name, "-enter-from") : _b, _c = rawProps.enterActiveClass, enterActiveClass = _c === void 0 ? "".concat(name, "-enter-active") : _c, _d = rawProps.enterToClass, enterToClass = _d === void 0 ? "".concat(name, "-enter-to") : _d, _e = rawProps.appearFromClass, appearFromClass = _e === void 0 ? enterFromClass : _e, _f = rawProps.appearActiveClass, appearActiveClass = _f === void 0 ? enterActiveClass : _f, _g = rawProps.appearToClass, appearToClass = _g === void 0 ? enterToClass : _g, _h = rawProps.leaveFromClass, leaveFromClass = _h === void 0 ? "".concat(name, "-leave-from") : _h, _j = rawProps.leaveActiveClass, leaveActiveClass = _j === void 0 ? "".concat(name, "-leave-active") : _j, _k = rawProps.leaveToClass, leaveToClass = _k === void 0 ? "".concat(name, "-leave-to") : _k;
    var durations = normalizeDuration(duration);
    var enterDuration = durations && durations[0];
    var leaveDuration = durations && durations[1];
    var onBeforeEnter = baseProps.onBeforeEnter, onEnter = baseProps.onEnter, onEnterCancelled = baseProps.onEnterCancelled, onLeave = baseProps.onLeave, onLeaveCancelled = baseProps.onLeaveCancelled, _l = baseProps.onBeforeAppear, onBeforeAppear = _l === void 0 ? onBeforeEnter : _l, _m = baseProps.onAppear, onAppear = _m === void 0 ? onEnter : _m, _o = baseProps.onAppearCancelled, onAppearCancelled = _o === void 0 ? onEnterCancelled : _o;
    var finishEnter = function (el, isAppear, done) {
        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    var finishLeave = function (el, done) {
        el._isLeaving = false;
        removeTransitionClass(el, leaveFromClass);
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    var makeEnterHook = function (isAppear) {
        return function (el, done) {
            var hook = isAppear ? onAppear : onEnter;
            var resolve = function () { return finishEnter(el, isAppear, done); };
            callHook(hook, [el, resolve]);
            nextFrame(function () {
                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!hasExplicitCallback(hook)) {
                    whenTransitionEnds(el, type, enterDuration, resolve);
                }
            });
        };
    };
    return extend(baseProps, {
        onBeforeEnter: function (el) {
            callHook(onBeforeEnter, [el]);
            addTransitionClass(el, enterFromClass);
            addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear: function (el) {
            callHook(onBeforeAppear, [el]);
            addTransitionClass(el, appearFromClass);
            addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave: function (el, done) {
            el._isLeaving = true;
            var resolve = function () { return finishLeave(el, done); };
            addTransitionClass(el, leaveFromClass);
            addTransitionClass(el, leaveActiveClass);
            forceReflow();
            nextFrame(function () {
                if (!el._isLeaving) {
                    return;
                }
                removeTransitionClass(el, leaveFromClass);
                addTransitionClass(el, leaveToClass);
                if (!hasExplicitCallback(onLeave)) {
                    whenTransitionEnds(el, type, leaveDuration, resolve);
                }
            });
            callHook(onLeave, [el, resolve]);
        },
        onEnterCancelled: function (el) {
            finishEnter(el, false);
            callHook(onEnterCancelled, [el]);
        },
        onAppearCancelled: function (el) {
            finishEnter(el, true);
            callHook(onAppearCancelled, [el]);
        },
        onLeaveCancelled: function (el) {
            finishLeave(el);
            callHook(onLeaveCancelled, [el]);
        }
    });
}
function normalizeDuration(duration) {
    if (duration == null) {
        return null;
    }
    else if (isObject(duration)) {
        return [NumberOf(duration.enter), NumberOf(duration.leave)];
    }
    else {
        var n = NumberOf(duration);
        return [n, n];
    }
}
function NumberOf(val) {
    var res = toNumber(val);
    if (!!(process.env.NODE_ENV !== "production")) {
        assertNumber(res, "<transition> explicit duration");
    }
    return res;
}
function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function (c) { return c && el.classList.add(c); });
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function (c) { return c && el.classList.remove(c); });
    var _vtc = el[vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) {
            el[vtcKey] = void 0;
        }
    }
}
function nextFrame(cb) {
    requestAnimationFrame(function () {
        requestAnimationFrame(cb);
    });
}
var endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    var id = el._endId = ++endId;
    var resolveIfNotStale = function () {
        if (id === el._endId) {
            resolve();
        }
    };
    if (explicitTimeout) {
        return setTimeout(resolveIfNotStale, explicitTimeout);
    }
    var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type) {
        return resolve();
    }
    var endEvent = type + "end";
    var ended = 0;
    var end = function () {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    var onEnd = function (e) {
        if (e.target === el && ++ended >= propCount) {
            end();
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    var getStyleProperties = function (key) { return (styles[key] || "").split(", "); };
    var transitionDelays = getStyleProperties("".concat(TRANSITION, "Delay"));
    var transitionDurations = getStyleProperties("".concat(TRANSITION, "Duration"));
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = getStyleProperties("".concat(ANIMATION, "Delay"));
    var animationDurations = getStyleProperties("".concat(ANIMATION, "Duration"));
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type = null;
    var timeout = 0;
    var propCount = 0;
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties("".concat(TRANSITION, "Property")).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(Math, __spreadArray([], __read(durations.map(function (d, i) { return toMs(d) + toMs(delays[i]); })), false));
}
function toMs(s) {
    if (s === "auto")
        return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
    return document.body.offsetHeight;
}
function patchClass(el, value, isSVG) {
    var transitionClasses = el[vtcKey];
    if (transitionClasses) {
        value = (value ? __spreadArray([value], __read(transitionClasses), false) : __spreadArray([], __read(transitionClasses), false)).join(" ");
    }
    if (value == null) {
        el.removeAttribute("class");
    }
    else if (isSVG) {
        el.setAttribute("class", value);
    }
    else {
        el.className = value;
    }
}
var vShowOriginalDisplay = Symbol("_vod");
var vShowHidden = Symbol("_vsh");
var vShow = {
    beforeMount: function (el, _a, _b) {
        var value = _a.value;
        var transition = _b.transition;
        el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) {
            transition.beforeEnter(el);
        }
        else {
            setDisplay(el, value);
        }
    },
    mounted: function (el, _a, _b) {
        var value = _a.value;
        var transition = _b.transition;
        if (transition && value) {
            transition.enter(el);
        }
    },
    updated: function (el, _a, _b) {
        var value = _a.value, oldValue = _a.oldValue;
        var transition = _b.transition;
        if (!value === !oldValue)
            return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                setDisplay(el, true);
                transition.enter(el);
            }
            else {
                transition.leave(el, function () {
                    setDisplay(el, false);
                });
            }
        }
        else {
            setDisplay(el, value);
        }
    },
    beforeUnmount: function (el, _a) {
        var value = _a.value;
        setDisplay(el, value);
    }
};
if (!!(process.env.NODE_ENV !== "production")) {
    vShow.name = "show";
}
function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
}
function initVShowForSSR() {
    vShow.getSSRProps = function (_a) {
        var value = _a.value;
        if (!value) {
            return { style: { display: "none" } };
        }
    };
}
var CSS_VAR_TEXT = Symbol(!!(process.env.NODE_ENV !== "production") ? "CSS_VAR_TEXT" : "");
function useCssVars(getter) {
    var instance = getCurrentInstance();
    if (!instance) {
        !!(process.env.NODE_ENV !== "production") && warn("useCssVars is called without current active component instance.");
        return;
    }
    var updateTeleports = instance.ut = function (vars) {
        if (vars === void 0) { vars = getter(instance.proxy); }
        Array.from(document.querySelectorAll("[data-v-owner=\"".concat(instance.uid, "\"]"))).forEach(function (node) { return setVarsOnNode(node, vars); });
    };
    if (!!(process.env.NODE_ENV !== "production")) {
        instance.getCssVars = function () { return getter(instance.proxy); };
    }
    var setVars = function () {
        var vars = getter(instance.proxy);
        setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    onMounted(function () {
        watchPostEffect(setVars);
        var ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, { childList: true });
        onUnmounted(function () { return ob.disconnect(); });
    });
}
function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        var suspense_1 = vnode.suspense;
        vnode = suspense_1.activeBranch;
        if (suspense_1.pendingBranch && !suspense_1.isHydrating) {
            suspense_1.effects.push(function () {
                setVarsOnVNode(suspense_1.activeBranch, vars);
            });
        }
    }
    while (vnode.component) {
        vnode = vnode.component.subTree;
    }
    if (vnode.shapeFlag & 1 && vnode.el) {
        setVarsOnNode(vnode.el, vars);
    }
    else if (vnode.type === Fragment) {
        vnode.children.forEach(function (c) { return setVarsOnVNode(c, vars); });
    }
    else if (vnode.type === Static) {
        var el = vnode.el, anchor = vnode.anchor;
        while (el) {
            setVarsOnNode(el, vars);
            if (el === anchor)
                break;
            el = el.nextSibling;
        }
    }
}
function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        var style = el.style;
        var cssText = "";
        for (var key in vars) {
            style.setProperty("--".concat(key), vars[key]);
            cssText += "--".concat(key, ": ").concat(vars[key], ";");
        }
        style[CSS_VAR_TEXT] = cssText;
    }
}
var displayRE = /(^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
    var e_1, _a;
    var style = el.style;
    var isCssString = isString(next);
    var hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!isString(prev)) {
                for (var key in prev) {
                    if (next[key] == null) {
                        setStyle(style, key, "");
                    }
                }
            }
            else {
                try {
                    for (var _b = __values(prev.split(";")), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var prevStyle = _c.value;
                        var key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                        if (next[key] == null) {
                            setStyle(style, key, "");
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        for (var key in next) {
            if (key === "display") {
                hasControlledDisplay = true;
            }
            setStyle(style, key, next[key]);
        }
    }
    else {
        if (isCssString) {
            if (prev !== next) {
                var cssVarText = style[CSS_VAR_TEXT];
                if (cssVarText) {
                    next += ";" + cssVarText;
                }
                style.cssText = next;
                hasControlledDisplay = displayRE.test(next);
            }
        }
        else if (prev) {
            el.removeAttribute("style");
        }
    }
    if (vShowOriginalDisplay in el) {
        el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[vShowHidden]) {
            style.display = "none";
        }
    }
}
var semicolonRE = /[^\\];\s*$/;
var importantRE = /\s*!important$/;
function setStyle(style, name, val) {
    if (isArray(val)) {
        val.forEach(function (v) { return setStyle(style, name, v); });
    }
    else {
        if (val == null)
            val = "";
        if (!!(process.env.NODE_ENV !== "production")) {
            if (semicolonRE.test(val)) {
                warn("Unexpected semicolon at the end of '".concat(name, "' style value: '").concat(val, "'"));
            }
        }
        if (name.startsWith("--")) {
            style.setProperty(name, val);
        }
        else {
            var prefixed = autoPrefix(style, name);
            if (importantRE.test(val)) {
                style.setProperty(hyphenate(prefixed), val.replace(importantRE, ""), "important");
            }
            else {
                style[prefixed] = val;
            }
        }
    }
}
var prefixes = ["Webkit", "Moz", "ms"];
var prefixCache = {};
function autoPrefix(style, rawName) {
    var cached = prefixCache[rawName];
    if (cached) {
        return cached;
    }
    var name = camelize(rawName);
    if (name !== "filter" && name in style) {
        return prefixCache[rawName] = name;
    }
    name = capitalize(name);
    for (var i = 0; i < prefixes.length; i++) {
        var prefixed = prefixes[i] + name;
        if (prefixed in style) {
            return prefixCache[rawName] = prefixed;
        }
    }
    return rawName;
}
var xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) {
            el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        var isBoolean = isSpecialBooleanAttr(key);
        if (value == null || isBoolean && !includeBooleanAttr(value)) {
            el.removeAttribute(key);
        }
        else {
            el.setAttribute(key, isBoolean ? "" : value);
        }
    }
}
function patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) {
            unmountChildren(prevChildren, parentComponent, parentSuspense);
        }
        el[key] = value == null ? "" : value;
        return;
    }
    var tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
        !tag.includes("-")) {
        var oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        var newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) {
            el.value = newValue;
        }
        if (value == null) {
            el.removeAttribute(key);
        }
        el._value = value;
        return;
    }
    var needRemove = false;
    if (value === "" || value == null) {
        var type = typeof el[key];
        if (type === "boolean") {
            value = includeBooleanAttr(value);
        }
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        }
        else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    }
    catch (e) {
        if (!!(process.env.NODE_ENV !== "production") && !needRemove) {
            warn("Failed setting prop \"".concat(key, "\" on <").concat(tag.toLowerCase(), ">: value ").concat(value, " is invalid."), e);
        }
    }
    needRemove && el.removeAttribute(key);
}
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
var veiKey = Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance) {
    if (instance === void 0) { instance = null; }
    var invokers = el[veiKey] || (el[veiKey] = {});
    var existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) {
        existingInvoker.value = !!(process.env.NODE_ENV !== "production") ? sanitizeEventValue(nextValue, rawName) : nextValue;
    }
    else {
        var _a = __read(parseName(rawName), 2), name = _a[0], options = _a[1];
        if (nextValue) {
            var invoker = invokers[rawName] = createInvoker(!!(process.env.NODE_ENV !== "production") ? sanitizeEventValue(nextValue, rawName) : nextValue, instance);
            addEventListener(el, name, invoker, options);
        }
        else if (existingInvoker) {
            removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
var optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
    var options;
    if (optionsModifierRE.test(name)) {
        options = {};
        var m = void 0;
        while (m = name.match(optionsModifierRE)) {
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    var event = name[2] === ":" ? name.slice(3) : hyphenate(name.slice(2));
    return [event, options];
}
var cachedNow = 0;
var p = /* @__PURE__ */ Promise.resolve();
var getNow = function () { return cachedNow || (p.then(function () { return cachedNow = 0; }), cachedNow = Date.now()); };
function createInvoker(initialValue, instance) {
    var invoker = function (e) {
        if (!e._vts) {
            e._vts = Date.now();
        }
        else if (e._vts <= invoker.attached) {
            return;
        }
        callWithAsyncErrorHandling(patchStopImmediatePropagation(e, invoker.value), instance, 5, [e]);
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
}
function sanitizeEventValue(value, propName) {
    if (isFunction(value) || isArray(value)) {
        return value;
    }
    warn("Wrong type passed as event handler to ".concat(propName, " - did you forget @ or : in front of your prop?\nExpected function or array of functions, received type ").concat(typeof value, "."));
    return NOOP;
}
function patchStopImmediatePropagation(e, value) {
    if (isArray(value)) {
        var originalStop_1 = e.stopImmediatePropagation;
        e.stopImmediatePropagation = function () {
            originalStop_1.call(e);
            e._stopped = true;
        };
        return value.map(function (fn) { return function (e2) { return !e2._stopped && fn && fn(e2); }; });
    }
    else {
        return value;
    }
}
var isNativeOn = function (key) { return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123; };
var patchProp = function (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    var isSVG = namespace === "svg";
    if (key === "class") {
        patchClass(el, nextValue, isSVG);
    }
    else if (key === "style") {
        patchStyle(el, prevValue, nextValue);
    }
    else if (isOn(key)) {
        if (!isModelListener(key)) {
            patchEvent(el, key, prevValue, nextValue, parentComponent);
        }
    }
    else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
        patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    }
    else {
        if (key === "true-value") {
            el._trueValue = nextValue;
        }
        else if (key === "false-value") {
            el._falseValue = nextValue;
        }
        patchAttr(el, key, nextValue, isSVG);
    }
};
function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") {
            return true;
        }
        if (key in el && isNativeOn(key) && isFunction(value)) {
            return true;
        }
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") {
        return false;
    }
    if (key === "form") {
        return false;
    }
    if (key === "list" && el.tagName === "INPUT") {
        return false;
    }
    if (key === "type" && el.tagName === "TEXTAREA") {
        return false;
    }
    if (key === "width" || key === "height") {
        var tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") {
            return false;
        }
    }
    if (isNativeOn(key) && isString(value)) {
        return false;
    }
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function defineCustomElement(options, hydrate2) {
    var Comp = defineComponent(options);
    var VueCustomElement = /** @class */ (function (_super) {
        __extends(VueCustomElement, _super);
        function VueCustomElement(initialProps) {
            return _super.call(this, Comp, initialProps, hydrate2) || this;
        }
        return VueCustomElement;
    }(VueElement));
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */
var defineSSRCustomElement = /* @__NO_SIDE_EFFECTS__ */ function (options) {
    return /* @__PURE__ */ defineCustomElement(options, hydrate);
};
var BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : /** @class */ (function () {
    function class_1() {
    }
    return class_1;
}());
var VueElement = /** @class */ (function (_super) {
    __extends(VueElement, _super);
    function VueElement(_def, _props, hydrate2) {
        if (_props === void 0) { _props = {}; }
        var _this = _super.call(this) || this;
        _this._def = _def;
        _this._props = _props;
        /**
         * @internal
         */
        _this._instance = null;
        _this._connected = false;
        _this._resolved = false;
        _this._numberProps = null;
        _this._ob = null;
        if (_this.shadowRoot && hydrate2) {
            hydrate2(_this._createVNode(), _this.shadowRoot);
        }
        else {
            if (!!(process.env.NODE_ENV !== "production") && _this.shadowRoot) {
                warn("Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use `defineSSRCustomElement`.");
            }
            _this.attachShadow({ mode: "open" });
            if (!_this._def.__asyncLoader) {
                _this._resolveProps(_this._def);
            }
        }
        return _this;
    }
    VueElement.prototype.connectedCallback = function () {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) {
                this._update();
            }
            else {
                this._resolveDef();
            }
        }
    };
    VueElement.prototype.disconnectedCallback = function () {
        var _this = this;
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        nextTick(function () {
            if (!_this._connected) {
                render(null, _this.shadowRoot);
                _this._instance = null;
            }
        });
    };
    /**
     * resolve inner component definition (handle possible async component)
     */
    VueElement.prototype._resolveDef = function () {
        var _this = this;
        this._resolved = true;
        for (var i = 0; i < this.attributes.length; i++) {
            this._setAttr(this.attributes[i].name);
        }
        this._ob = new MutationObserver(function (mutations) {
            var e_2, _a;
            try {
                for (var mutations_1 = __values(mutations), mutations_1_1 = mutations_1.next(); !mutations_1_1.done; mutations_1_1 = mutations_1.next()) {
                    var m = mutations_1_1.value;
                    _this._setAttr(m.attributeName);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (mutations_1_1 && !mutations_1_1.done && (_a = mutations_1.return)) _a.call(mutations_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
        this._ob.observe(this, { attributes: true });
        var resolve = function (def, isAsync) {
            if (isAsync === void 0) { isAsync = false; }
            var props = def.props, styles = def.styles;
            var numberProps;
            if (props && !isArray(props)) {
                for (var key in props) {
                    var opt = props[key];
                    if (opt === Number || opt && opt.type === Number) {
                        if (key in _this._props) {
                            _this._props[key] = toNumber(_this._props[key]);
                        }
                        (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[camelize$1(key)] = true;
                    }
                }
            }
            _this._numberProps = numberProps;
            if (isAsync) {
                _this._resolveProps(def);
            }
            _this._applyStyles(styles);
            _this._update();
        };
        var asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            asyncDef().then(function (def) { return resolve(def, true); });
        }
        else {
            resolve(this._def);
        }
    };
    VueElement.prototype._resolveProps = function (def) {
        var e_3, _a, e_4, _b;
        var props = def.props;
        var declaredPropKeys = isArray(props) ? props : Object.keys(props || {});
        try {
            for (var _c = __values(Object.keys(this)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var key = _d.value;
                if (key[0] !== "_" && declaredPropKeys.includes(key)) {
                    this._setProp(key, this[key], true, false);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var _loop_1 = function (key) {
            Object.defineProperty(this_1, key, {
                get: function () {
                    return this._getProp(key);
                },
                set: function (val) {
                    this._setProp(key, val);
                }
            });
        };
        var this_1 = this;
        try {
            for (var _e = __values(declaredPropKeys.map(camelize$1)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var key = _f.value;
                _loop_1(key);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    VueElement.prototype._setAttr = function (key) {
        var value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        var camelKey = camelize$1(key);
        if (this._numberProps && this._numberProps[camelKey]) {
            value = toNumber(value);
        }
        this._setProp(camelKey, value, false);
    };
    /**
     * @internal
     */
    VueElement.prototype._getProp = function (key) {
        return this._props[key];
    };
    /**
     * @internal
     */
    VueElement.prototype._setProp = function (key, val, shouldReflect, shouldUpdate) {
        if (shouldReflect === void 0) { shouldReflect = true; }
        if (shouldUpdate === void 0) { shouldUpdate = true; }
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) {
                this._update();
            }
            if (shouldReflect) {
                if (val === true) {
                    this.setAttribute(hyphenate(key), "");
                }
                else if (typeof val === "string" || typeof val === "number") {
                    this.setAttribute(hyphenate(key), val + "");
                }
                else if (!val) {
                    this.removeAttribute(hyphenate(key));
                }
            }
        }
    };
    VueElement.prototype._update = function () {
        render(this._createVNode(), this.shadowRoot);
    };
    VueElement.prototype._createVNode = function () {
        var _this = this;
        var vnode = createVNode(this._def, extend({}, this._props));
        if (!this._instance) {
            vnode.ce = function (instance) {
                _this._instance = instance;
                instance.isCE = true;
                if (!!(process.env.NODE_ENV !== "production")) {
                    instance.ceReload = function (newStyles) {
                        if (_this._styles) {
                            _this._styles.forEach(function (s) { return _this.shadowRoot.removeChild(s); });
                            _this._styles.length = 0;
                        }
                        _this._applyStyles(newStyles);
                        _this._instance = null;
                        _this._update();
                    };
                }
                var dispatch = function (event, args) {
                    _this.dispatchEvent(new CustomEvent(event, {
                        detail: args
                    }));
                };
                instance.emit = function (event) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    dispatch(event, args);
                    if (hyphenate(event) !== event) {
                        dispatch(hyphenate(event), args);
                    }
                };
                var parent = _this;
                while (parent = parent && (parent.parentNode || parent.host)) {
                    if (parent instanceof VueElement) {
                        instance.parent = parent._instance;
                        instance.provides = parent._instance.provides;
                        break;
                    }
                }
            };
        }
        return vnode;
    };
    VueElement.prototype._applyStyles = function (styles) {
        var _this = this;
        if (styles) {
            styles.forEach(function (css) {
                var s = document.createElement("style");
                s.textContent = css;
                _this.shadowRoot.appendChild(s);
                if (!!(process.env.NODE_ENV !== "production")) {
                    (_this._styles || (_this._styles = [])).push(s);
                }
            });
        }
    };
    return VueElement;
}(BaseClass));
function useCssModule(name) {
    if (name === void 0) { name = "$style"; }
    {
        var instance = getCurrentInstance();
        if (!instance) {
            !!(process.env.NODE_ENV !== "production") && warn("useCssModule must be called inside setup()");
            return EMPTY_OBJ;
        }
        var modules = instance.type.__cssModules;
        if (!modules) {
            !!(process.env.NODE_ENV !== "production") && warn("Current instance does not have CSS modules injected.");
            return EMPTY_OBJ;
        }
        var mod = modules[name];
        if (!mod) {
            !!(process.env.NODE_ENV !== "production") && warn("Current instance does not have CSS module named \"".concat(name, "\"."));
            return EMPTY_OBJ;
        }
        return mod;
    }
}
var positionMap = /* @__PURE__ */ new WeakMap();
var newPositionMap = /* @__PURE__ */ new WeakMap();
var moveCbKey = Symbol("_moveCb");
var enterCbKey = Symbol("_enterCb");
var TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ extend({}, TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup: function (props, _a) {
        var slots = _a.slots;
        var instance = getCurrentInstance();
        var state = useTransitionState();
        var prevChildren;
        var children;
        onUpdated(function () {
            if (!prevChildren.length) {
                return;
            }
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                return;
            }
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            var movedChildren = prevChildren.filter(applyTranslation);
            forceReflow();
            movedChildren.forEach(function (c) {
                var el = c.el;
                var style = el.style;
                addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                var cb = el[moveCbKey] = function (e) {
                    if (e && e.target !== el) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[moveCbKey] = null;
                        removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return function () {
            var rawProps = toRaw(props);
            var cssTransitionProps = resolveTransitionProps(rawProps);
            var tag = rawProps.tag || Fragment;
            prevChildren = [];
            if (children) {
                for (var i = 0; i < children.length; i++) {
                    var child = children[i];
                    if (child.el && child.el instanceof Element) {
                        prevChildren.push(child);
                        setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
                        positionMap.set(child, child.el.getBoundingClientRect());
                    }
                }
            }
            children = slots.default ? getTransitionRawChildren(slots.default()) : [];
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                if (child.key != null) {
                    setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
                }
                else if (!!(process.env.NODE_ENV !== "production")) {
                    warn("<TransitionGroup> children must be keyed.");
                }
            }
            return createVNode(tag, null, children);
        };
    }
};
var removeMode = function (props) { return delete props.mode; };
/* @__PURE__ */ removeMode(TransitionGroupImpl.props);
var TransitionGroup = TransitionGroupImpl;
function callPendingCbs(c) {
    var el = c.el;
    if (el[moveCbKey]) {
        el[moveCbKey]();
    }
    if (el[enterCbKey]) {
        el[enterCbKey]();
    }
}
function recordPosition(c) {
    newPositionMap.set(c, c.el.getBoundingClientRect());
}
function applyTranslation(c) {
    var oldPos = positionMap.get(c);
    var newPos = newPositionMap.get(c);
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        var s = c.el.style;
        s.transform = s.webkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = "0s";
        return c;
    }
}
function hasCSSTransform(el, root, moveClass) {
    var clone = el.cloneNode();
    var _vtc = el[vtcKey];
    if (_vtc) {
        _vtc.forEach(function (cls) {
            cls.split(/\s+/).forEach(function (c) { return c && clone.classList.remove(c); });
        });
    }
    moveClass.split(/\s+/).forEach(function (c) { return c && clone.classList.add(c); });
    clone.style.display = "none";
    var container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    var hasTransform = getTransitionInfo(clone).hasTransform;
    container.removeChild(clone);
    return hasTransform;
}
var getModelAssigner = function (vnode) {
    var fn = vnode.props["onUpdate:modelValue"] || false;
    return isArray(fn) ? function (value) { return invokeArrayFns(fn, value); } : fn;
};
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    var target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
var assignKey = Symbol("_assign");
var vModelText = {
    created: function (el, _a, vnode) {
        var _b = _a.modifiers, lazy = _b.lazy, trim = _b.trim, number = _b.number;
        el[assignKey] = getModelAssigner(vnode);
        var castToNumber = number || vnode.props && vnode.props.type === "number";
        addEventListener(el, lazy ? "change" : "input", function (e) {
            if (e.target.composing)
                return;
            var domValue = el.value;
            if (trim) {
                domValue = domValue.trim();
            }
            if (castToNumber) {
                domValue = looseToNumber(domValue);
            }
            el[assignKey](domValue);
        });
        if (trim) {
            addEventListener(el, "change", function () {
                el.value = el.value.trim();
            });
        }
        if (!lazy) {
            addEventListener(el, "compositionstart", onCompositionStart);
            addEventListener(el, "compositionend", onCompositionEnd);
            addEventListener(el, "change", onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted: function (el, _a) {
        var value = _a.value;
        el.value = value == null ? "" : value;
    },
    beforeUpdate: function (el, _a, vnode) {
        var value = _a.value, _b = _a.modifiers, lazy = _b.lazy, trim = _b.trim, number = _b.number;
        el[assignKey] = getModelAssigner(vnode);
        if (el.composing)
            return;
        var elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? looseToNumber(el.value) : el.value;
        var newValue = value == null ? "" : value;
        if (elValue === newValue) {
            return;
        }
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) {
                return;
            }
            if (trim && el.value.trim() === newValue) {
                return;
            }
        }
        el.value = newValue;
    }
};
var vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created: function (el, _, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", function () {
            var modelValue = el._modelValue;
            var elementValue = getValue(el);
            var checked = el.checked;
            var assign = el[assignKey];
            if (isArray(modelValue)) {
                var index = looseIndexOf(modelValue, elementValue);
                var found = index !== -1;
                if (checked && !found) {
                    assign(modelValue.concat(elementValue));
                }
                else if (!checked && found) {
                    var filtered = __spreadArray([], __read(modelValue), false);
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            }
            else if (isSet(modelValue)) {
                var cloned = new Set(modelValue);
                if (checked) {
                    cloned.add(elementValue);
                }
                else {
                    cloned.delete(elementValue);
                }
                assign(cloned);
            }
            else {
                assign(getCheckboxValue(el, checked));
            }
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate: function (el, binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        setChecked(el, binding, vnode);
    }
};
function setChecked(el, _a, vnode) {
    var value = _a.value, oldValue = _a.oldValue;
    el._modelValue = value;
    if (isArray(value)) {
        el.checked = looseIndexOf(value, vnode.props.value) > -1;
    }
    else if (isSet(value)) {
        el.checked = value.has(vnode.props.value);
    }
    else if (value !== oldValue) {
        el.checked = looseEqual(value, getCheckboxValue(el, true));
    }
}
var vModelRadio = {
    created: function (el, _a, vnode) {
        var value = _a.value;
        el.checked = looseEqual(value, vnode.props.value);
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", function () {
            el[assignKey](getValue(el));
        });
    },
    beforeUpdate: function (el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        el[assignKey] = getModelAssigner(vnode);
        if (value !== oldValue) {
            el.checked = looseEqual(value, vnode.props.value);
        }
    }
};
var vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created: function (el, _a, vnode) {
        var value = _a.value, number = _a.modifiers.number;
        var isSetModel = isSet(value);
        addEventListener(el, "change", function () {
            var selectedVal = Array.prototype.filter.call(el.options, function (o) { return o.selected; }).map(function (o) { return number ? looseToNumber(getValue(o)) : getValue(o); });
            el[assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            nextTick(function () {
                el._assigning = false;
            });
        });
        el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted: function (el, _a) {
        var value = _a.value, number = _a.modifiers.number;
        setSelected(el, value);
    },
    beforeUpdate: function (el, _binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
    },
    updated: function (el, _a) {
        var value = _a.value, number = _a.modifiers.number;
        if (!el._assigning) {
            setSelected(el, value);
        }
    }
};
function setSelected(el, value, number) {
    var isMultiple = el.multiple;
    var isArrayValue = isArray(value);
    if (isMultiple && !isArrayValue && !isSet(value)) {
        !!(process.env.NODE_ENV !== "production") && warn("<select multiple v-model> expects an Array or Set value for its binding, but got ".concat(Object.prototype.toString.call(value).slice(8, -1), "."));
        return;
    }
    var _loop_2 = function (i, l) {
        var option = el.options[i];
        var optionValue = getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                var optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") {
                    option.selected = value.some(function (v) { return String(v) === String(optionValue); });
                }
                else {
                    option.selected = looseIndexOf(value, optionValue) > -1;
                }
            }
            else {
                option.selected = value.has(optionValue);
            }
        }
        else if (looseEqual(getValue(option), value)) {
            if (el.selectedIndex !== i)
                el.selectedIndex = i;
            return { value: void 0 };
        }
    };
    for (var i = 0, l = el.options.length; i < l; i++) {
        var state_1 = _loop_2(i, l);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    if (!isMultiple && el.selectedIndex !== -1) {
        el.selectedIndex = -1;
    }
}
function getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked) {
    var key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
var vModelDynamic = {
    created: function (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "created");
    },
    mounted: function (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate: function (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated: function (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function resolveDynamicModel(tagName, type) {
    switch (tagName) {
        case "SELECT":
            return vModelSelect;
        case "TEXTAREA":
            return vModelText;
        default:
            switch (type) {
                case "checkbox":
                    return vModelCheckbox;
                case "radio":
                    return vModelRadio;
                default:
                    return vModelText;
            }
    }
}
function callModelHook(el, binding, vnode, prevVNode, hook) {
    var modelToUse = resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    var fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function initVModelForSSR() {
    vModelText.getSSRProps = function (_a) {
        var value = _a.value;
        return ({ value: value });
    };
    vModelRadio.getSSRProps = function (_a, vnode) {
        var value = _a.value;
        if (vnode.props && looseEqual(vnode.props.value, value)) {
            return { checked: true };
        }
    };
    vModelCheckbox.getSSRProps = function (_a, vnode) {
        var value = _a.value;
        if (isArray(value)) {
            if (vnode.props && looseIndexOf(value, vnode.props.value) > -1) {
                return { checked: true };
            }
        }
        else if (isSet(value)) {
            if (vnode.props && value.has(vnode.props.value)) {
                return { checked: true };
            }
        }
        else if (value) {
            return { checked: true };
        }
    };
    vModelDynamic.getSSRProps = function (binding, vnode) {
        if (typeof vnode.type !== "string") {
            return;
        }
        var modelToUse = resolveDynamicModel(
        // resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) {
            return modelToUse.getSSRProps(binding, vnode);
        }
    };
}
var systemModifiers = ["ctrl", "shift", "alt", "meta"];
var modifierGuards = {
    stop: function (e) { return e.stopPropagation(); },
    prevent: function (e) { return e.preventDefault(); },
    self: function (e) { return e.target !== e.currentTarget; },
    ctrl: function (e) { return !e.ctrlKey; },
    shift: function (e) { return !e.shiftKey; },
    alt: function (e) { return !e.altKey; },
    meta: function (e) { return !e.metaKey; },
    left: function (e) { return "button" in e && e.button !== 0; },
    middle: function (e) { return "button" in e && e.button !== 1; },
    right: function (e) { return "button" in e && e.button !== 2; },
    exact: function (e, modifiers) { return systemModifiers.some(function (m) { return e["".concat(m, "Key")] && !modifiers.includes(m); }); }
};
var withModifiers = function (fn, modifiers) {
    var cache = fn._withMods || (fn._withMods = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        for (var i = 0; i < modifiers.length; i++) {
            var guard = modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers))
                return;
        }
        return fn.apply(void 0, __spreadArray([event], __read(args), false));
    });
};
var keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
var withKeys = function (fn, modifiers) {
    var cache = fn._withKeys || (fn._withKeys = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function (event) {
        if (!("key" in event)) {
            return;
        }
        var eventKey = hyphenate(event.key);
        if (modifiers.some(function (k) { return k === eventKey || keyNames[k] === eventKey; })) {
            return fn(event);
        }
    });
};
var rendererOptions = /* @__PURE__ */ extend({ patchProp: patchProp }, nodeOps);
var renderer;
var enabledHydration = false;
function ensureRenderer() {
    return renderer || (renderer = createRenderer(rendererOptions));
}
function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : createHydrationRenderer(rendererOptions);
    enabledHydration = true;
    return renderer;
}
var render = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    (_a = ensureRenderer()).render.apply(_a, __spreadArray([], __read(args), false));
};
var hydrate = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    (_a = ensureHydrationRenderer()).hydrate.apply(_a, __spreadArray([], __read(args), false));
};
var createApp = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var app = (_a = ensureRenderer()).createApp.apply(_a, __spreadArray([], __read(args), false));
    if (!!(process.env.NODE_ENV !== "production")) {
        injectNativeTagCheck(app);
        injectCompilerOptionsCheck(app);
    }
    var mount = app.mount;
    app.mount = function (containerOrSelector) {
        var container = normalizeContainer(containerOrSelector);
        if (!container)
            return;
        var component = app._component;
        if (!isFunction(component) && !component.render && !component.template) {
            component.template = container.innerHTML;
        }
        container.innerHTML = "";
        var proxy = mount(container, false, resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
var createSSRApp = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var app = (_a = ensureHydrationRenderer()).createApp.apply(_a, __spreadArray([], __read(args), false));
    if (!!(process.env.NODE_ENV !== "production")) {
        injectNativeTagCheck(app);
        injectCompilerOptionsCheck(app);
    }
    var mount = app.mount;
    app.mount = function (containerOrSelector) {
        var container = normalizeContainer(containerOrSelector);
        if (container) {
            return mount(container, true, resolveRootNamespace(container));
        }
    };
    return app;
};
function resolveRootNamespace(container) {
    if (container instanceof SVGElement) {
        return "svg";
    }
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) {
        return "mathml";
    }
}
function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: function (tag) { return isHTMLTag(tag) || isSVGTag(tag) || isMathMLTag(tag); },
        writable: false
    });
}
function injectCompilerOptionsCheck(app) {
    if (isRuntimeOnly()) {
        var isCustomElement_1 = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get: function () {
                return isCustomElement_1;
            },
            set: function () {
                warn("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
            }
        });
        var compilerOptions_1 = app.config.compilerOptions;
        var msg_1 = "The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka \"full build\"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader's `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc";
        Object.defineProperty(app.config, "compilerOptions", {
            get: function () {
                warn(msg_1);
                return compilerOptions_1;
            },
            set: function () {
                warn(msg_1);
            }
        });
    }
}
function normalizeContainer(container) {
    if (isString(container)) {
        var res = document.querySelector(container);
        if (!!(process.env.NODE_ENV !== "production") && !res) {
            warn("Failed to mount app: mount target selector \"".concat(container, "\" returned null."));
        }
        return res;
    }
    if (!!(process.env.NODE_ENV !== "production") && window.ShadowRoot && container instanceof window.ShadowRoot && container.mode === "closed") {
        warn("mounting on a ShadowRoot with `{mode: \"closed\"}` may lead to unpredictable bugs");
    }
    return container;
}
var ssrDirectiveInitialized = false;
var initDirectivesForSSR = function () {
    if (!ssrDirectiveInitialized) {
        ssrDirectiveInitialized = true;
        initVModelForSSR();
        initVShowForSSR();
    }
};
export { Transition, TransitionGroup, VueElement, createApp, createSSRApp, defineCustomElement, defineSSRCustomElement, hydrate, initDirectivesForSSR, render, useCssModule, useCssVars, vModelCheckbox, vModelDynamic, vModelRadio, vModelSelect, vModelText, vShow, withKeys, withModifiers };
